import { combineClass, type JSX } from "cdui-js";
import './difi-button.css';

export type DiFiButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  onClick?: (e: MouseEvent) => void;
  text: string;
  class?: string;
  style?: JSX.CSSProperties;
  render?: () => JSX.Element;
};

export const DiFiButton = (props: DiFiButtonProps) => {
  return (
    <div
      class={combineClass(
        `di-fi-button${props.disabled ? ' di-fi-button--disabled' : ''}${props.loading ? ' di-fi-button--loading' : ''}`,
        props.class,
      )}
      style={props.style}
      onclick={(e) => {
        if (props.disabled || props.loading) return;
        props.onClick?.(e);
      }}
    >
      {props.render ? props.render() : props.text}
    </div>
  );
};